import { pathOr } from 'ramda';

import { PAGE_SUCCESS } from 'store/app/actions';

import { types } from './actions';
import { MODES } from './constants';

const initialState = {
  isLoading: false,
  isOpen: false,
  isSaving: false,
  mode: MODES.CREATE,
  supplierFacility: null,
  supplierFacilityId: null,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case PAGE_SUCCESS:
      return {
        ...initialState,
      };
    case types.CLOSE:
      return {
        ...initialState,
      };
    case types.SET_SUPPLIER_FACILITY:
      return {
        ...state,
        supplierFacility: payload.supplierFacility,
      };
    case types.OPEN_ERROR:
      return {
        ...state,
        isLoading: false,
        isOpen: false,
      };
    case types.OPEN_REQUEST:
      return {
        ...state,
        isLoading: true,
        isOpen: true,
        mode: pathOr(MODES.CREATE, ['mode'], payload),
        supplierFacilityId: pathOr(null, ['supplierFacilityId'], payload),
      };
    case types.OPEN_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case types.SAVE_ERROR:
      return {
        ...state,
        isSaving: false,
      };
    case types.SAVE_REQUEST:
      return {
        ...state,
        isSaving: true,
      };
    case types.SAVE_SUCCESS:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) =>
  state.modules.settings.company.supplierFacilities.drawer;

export const getSupplierFacility = (state) => getScope(state).supplierFacility;

export const getSupplierFacilityId = (state) =>
  getScope(state).supplierFacilityId;

export const getIsLoading = (state) => getScope(state).isLoading;

export const getIsOpen = (state) => getScope(state).isOpen;

export const getIsSaving = (state) => getScope(state).isSaving;

export const getMode = (state) => getScope(state).mode;

export const getLogoId = (state) =>
  pathOr(null, ['supplierFacility', 'logo', 'id'], getScope(state));
